/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Shared subset of the public organization config response (GET /public/organizations/config/:id).
 * Contains only fields consumed cross-app (consumer-login reads these from consumer-portal API).
 */
export interface PublicOrganizationConfig {
    CustomSmtp?: boolean;
    HiddenFeatures?: string[];
}
